import React from "react";
import formateText from "../../../utils/Formate";

const SetupInput = ({
  placeHolder,
  name,
  type,
  allTimeValue,
  valueUpdate,
  disabled,
}) => {
  const defaultVAlueFormate = (data) => {
   // if (!allTimeValue) return "";
    if (data === null || data === undefined) return ""; // allow 0
    if (type === "date") return data;

    if (type === "date") {
      const DateObj = new Date(data);
      return `${DateObj.getFullYear()}/${
        DateObj.getMonth() + 1
      }/${DateObj.getDate()}`;
    }
    return data;
  };

  return (
    <div className="w-full">
      <label className="font-semibold" htmlFor={placeHolder}>
        {formateText(placeHolder)}
      </label>

      <input
        disabled={disabled}
       // value={defaultVAlueFormate(allTimeValue)}
        value={type === "number" ? allTimeValue ?? "" : defaultVAlueFormate(allTimeValue)}
        required
        min={0}
        step="any" // ✅ allows decimals
        maxLength={name==="barcodeNumber"?16:2147483647}
        type={type}
        id={placeHolder}
        onChange={valueUpdate}
        name={name}
        className="w-full border border-stone-300 pl-3 mt-1.5 h-11 outline-none rounded-xl bg-stone-50 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-500/15"
      />
    </div>
  );
};

export default SetupInput;
